<div class="component-container">

    <span *ngIf=" !responsiveService.isScreenSmall()">
        <span class="create-poll">
            <button mat-raised-button color="warn" (click)="navigateToChoosePollTemplate()"
                matTooltip="Choose a template to create an event poll" [disabled]="disableCreatePollButton">{{ 'create'
                | transMigrated | async}}</button>
        </span>
    </span>
</div>
